import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section id="home" className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-124">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80")'
    }} data-id="element-125">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-[#0f5f5f]/70 mix-blend-multiply" data-id="element-126" />
        <div className="absolute inset-0 bg-black/30" data-id="element-127" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center text-white" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-129">
          <span className="inline-block px-4 py-1.5 mb-6 rounded-full bg-[#d4a74a]/20 border border-[#d4a74a]/50 text-[#d4a74a] text-sm font-semibold tracking-wider uppercase backdrop-blur-sm" data-id="element-130">
            Non-Governmental Organization
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-5xl md:text-7xl lg:text-8xl font-bold font-serif mb-6 leading-tight" data-id="element-131">
          Fair Gaming Space
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-132">
          Building a space of honesty, understanding, and cooperation in the
          gambling industry. Protecting player rights, helping prevent and
          overcome addiction.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-133">
          <Button variant="primary" size="lg" onClick={() => document.getElementById('about')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-134">
            Learn More
          </Button>
          <Button variant="outline" size="lg" onClick={() => document.getElementById('activities')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-135">
            Our Projects
          </Button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 cursor-pointer" onClick={() => document.getElementById('mission')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-136">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} data-id="element-137">
          <ChevronDown className="text-white/70 w-10 h-10" data-id="element-138" />
        </motion.div>
      </motion.div>
    </section>;
}